import React, { Component } from 'react';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import './../../custom.css';
import './../../pages/invoice.css';
import validator from 'validator';

  const arRequired = (value) => {
    if (!value.toString().trim().length) {
      // We can return string or jsx as the 'error' prop for the validated Component
      return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> .هذا الحقل مطلوب</div>;
    }
  };
  const required = (value) => {
    if (!value.toString().trim().length) {
      // We can return string or jsx as the 'error' prop for the validated Component
      return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
    }
  };
  const FullName = (value) => {
      var patt = new RegExp("[a-zA-Zا-ى]+ [a-zA-Zا-ى]+");
      if(!patt.test(value) || value[0] === " " || value[value.length - 1] === " "){
          return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter your full name.</div>;
      }
  };
  const arName = (value) => {
    let regex = /^[\u0621-\u064A]+ [\u0621-\u064A]+ [\u0621-\u064A]+ [\u0621-\u064A]+$/;
    if(!regex.test(value)){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> .من فضلك أدخل الاسم الرباعى بطريقة صحيحة</div>;
    }
  };
  const email = (value) => {
    if (!validator.isEmail(value)) {
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid email.</div>;
    }
  };
  const PhoneNumber = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length > 14 || value.toString().trim().length < 8 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Phone number.</div>;
    }
  };
  const nationalID = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length !== 14){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid National ID.</div>;
    }
  };

class subData extends Component {
      constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phone: '',
            national_id: ""
        };
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleNationalIdChange = this.handleNationalIdChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }
  
  handleNameChange(e) {
    this.setState({name: e.target.value}); 
  }
  handleEmailChange(e) {
    this.setState({email: e.target.value}); 
  }
  handlePhoneChange(e) {
    this.setState({phone: e.target.value}); 
  }
  handleNationalIdChange(e) {
    this.setState({national_id: e.target.value});
  }

  handleSubmit(event) {
    event.preventDefault();
    let client_data = {
        'name': this.state.name,
        'email': this.state.email,
        'phone': this.state.phone,
        "national_id": this.state.national_id
    }
    this.props.setSubDeliveryData(client_data);
  }

  render() {
    return (
        <div className="panel panel-default credit-card-box">
            <div className="delivery_new" id="cash_content">
                <h3>Add your contact information</h3>
                <Form onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-md-6 col-sm-6 col-xs-12" key={this.props.nid}>
                          {this.props.nid === true ?
                            <div className="newInput">
                                    <Input type="text" className="form-control cardInput ar_name" name="c_pan_U" placeholder="الاسم الرباعى" 
                                        value={this.state.name}
                                        onChange={this.handleNameChange}
                                        validations={[arRequired, arName]}
                                    />
                            </div>
                          :
                            <div className="newInput">
                                    <Input type="text" className="form-control cardInput" name="c_pan_U" placeholder="Full name" 
                                        value={this.state.name}
                                        onChange={this.handleNameChange}
                                        validations={[required, this.props.nid === true ? arName : FullName]}
                                    />
                            </div>
                          }
                        </div>
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="newInput">
                                    <Input type="text" className="form-control cardInput" name="c_pan_U" placeholder="Email" 
                                        value={this.state.email}
                                        onChange={this.handleEmailChange}
                                        validations={[required, email]}
                                    />
                            </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="newInput">
                                    <Input type="number" pattern="[0-9]*" className="form-control cardInput" name="c_pan_U" placeholder="Phone" 
                                        value={this.state.phone} 
                                        onChange={this.handlePhoneChange}
                                        validations={[required, PhoneNumber]}
                                    />
                            </div>
                        </div>
                        {this.props.nid === true &&
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                              <div className="newInput">
                                  <Input 
                                      type="text" 
                                      name="national_id" 
                                      placeholder="National ID"
                                      value={this.state.national_id}
                                      onChange={this.handleNationalIdChange}
                                      validations={[required, nationalID]}
                                  />
                              </div>
                          </div>
                        }
                      </div>
                    
                    <div className='text-center'>
                        <Button className="confirmBtnNew">Next</Button>
                    </div>
                    
                </Form>
            </div>
        </div>
    );
  }
}

export default subData;
